import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, scrollToSection } from "../lib/scroll";

const LINKS = [
  { label: "Manifesto", hash: "#manifesto", id: "nav-link-manifesto" },
  { label: "The Bake", hash: "#menu", id: "nav-link-menu" },
  { label: "Gallery", hash: "#gallery", id: "nav-link-gallery" },
  { label: "Contact", hash: "#contact", id: "nav-link-contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, hash) => {
    e.preventDefault();
    scrollToSection(hash);
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-eggshell/85 backdrop-blur-md border-b border-line"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-[1440px] mx-auto flex items-center justify-between px-5 sm:px-10 h-16 sm:h-20">
        <a
          href="#top"
          data-testid="nav-brand-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3 group"
        >
          <span className="w-9 h-9 rounded-full border-[1.5px] border-ink flex items-center justify-center font-display italic font-bold text-sm group-hover:bg-ink group-hover:text-eggshell transition-colors duration-300">
            Z
          </span>
          <span className="font-display font-bold text-lg leading-none tracking-tight">
            Zoni&apos;s
            <span className="block font-mono text-[9px] uppercase tracking-[0.35em] text-mutedbrown font-normal mt-0.5">
              Bakehouse
            </span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              data-testid={l.id}
              onClick={(e) => go(e, l.hash)}
              className="font-mono text-[11px] uppercase tracking-[0.22em] text-cocoa hover:text-rust transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href={PHONE_TEL}
          data-testid="nav-call-button"
          className="flex items-center gap-2 bg-ink text-eggshell pl-4 pr-5 py-2.5 rounded-full font-mono text-[11px] uppercase tracking-[0.18em] hover:bg-rust transition-colors duration-300"
        >
          <Phone size={13} strokeWidth={2.2} />
          <span className="hidden sm:inline">{PHONE_DISPLAY.replace("+91 ", "")}</span>
          <span className="sm:hidden">Call</span>
        </a>
      </nav>
    </header>
  );
}
